import { create } from "zustand";

export const useComponentStore = create((set) => ({
  open: false,
  setOpen: (value) => {
    set({ open: value });
  },
  notificationCount: 0,
  setNotificationCount: (value) => {
    set({ notificationCount: value });
  },
  notifications: [],
  setNotifications: (value) => {
    set({ notifications: value });
  },
  openDrawer: false,
  setOpenDrawer: (value) => {
    set({ openDrawer: value });
  },
}));
